import React from 'react';

import type { WizardProgressBarProps } from './types';

/**
 * Generic progress bar component for wizards.
 * Displays visual progress and optional percentage.
 */
export const WizardProgressBar: React.FC<WizardProgressBarProps> = ({
  currentStep,
  totalSteps,
  stepTitle,
  showPercentage = true,
  percentage: percentageProp,
}) => {
  // Use prop if provided, otherwise calculate from steps (backward compatible)
  const percentage =
    percentageProp ??
    (totalSteps > 0 ? Math.round((currentStep / totalSteps) * 100) : 0);
  const ariaLabel = stepTitle
    ? `Step ${currentStep} of ${totalSteps}: ${stepTitle}`
    : `Step ${currentStep} of ${totalSteps}`;

  return (
    <div className="mb-8 flex items-center justify-between">
      <div className="mr-4 flex-1">
        <div className="bg-chariot-background-tertiary relative h-2 w-full overflow-hidden rounded-full">
          <div
            className="bg-chariot-brand-primary absolute top-0 left-0 h-full transition-all duration-300"
            style={{ width: `${percentage}%` }}
            role="progressbar"
            aria-valuenow={percentage}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={ariaLabel}
          />
        </div>
      </div>
      {showPercentage && (
        <span className="text-chariot-text-secondary text-sm font-medium">
          {percentage}%
        </span>
      )}
    </div>
  );
};
